import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyC2P2U_x7s8ittNHDz46X4oRPEOoug2SYU",
    authDomain: "tcetrf.firebaseapp.com",
    projectId: "tcetrf",
    storageBucket: "tcetrf.firebasestorage.app",
    messagingSenderId: "878545757053",
    appId: "1:878545757053:web:94246842ac9bdf7a786214"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

export default app;
